import { render, staticRenderFns } from "./config-scene-exceptions.vue?vue&type=template&id=2cd053b2&scoped=true&"
import script from "./config-scene-exceptions.vue?vue&type=script&lang=js&"
export * from "./config-scene-exceptions.vue?vue&type=script&lang=js&"
import style0 from "./config-scene-exceptions.vue?vue&type=style&index=0&id=2cd053b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd053b2",
  null
  
)

export default component.exports